import { render, staticRenderFns } from "./AddRoleDialog.vue?vue&type=template&id=020a5dc9&scoped=true"
import script from "./AddRoleDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AddRoleDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AddRoleDialog.vue?vue&type=style&index=0&id=020a5dc9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020a5dc9",
  null
  
)

export default component.exports